import { render, staticRenderFns } from "./RegisterSearchGrid.vue?vue&type=template&id=542100e6&"
import script from "./RegisterSearchGrid.vue?vue&type=script&lang=ts&"
export * from "./RegisterSearchGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports